<template>
  <div class="highway-wrap" v-loading='importLoading'>
    <div class="top-wrap">
      <el-button @click="onClickBack" icon="el-icon-arrow-left" size="small" style="margin-right: 20px;"></el-button>
      <div class="mr20">
        <span>委托商：</span>
        <el-input v-model="searchParams.consignor" placeholder="请输入委托商" style="width: 150px;" size="small"></el-input>
      </div>
      <div class="mr20">
        <span>品牌：</span>
        <el-input v-model="searchParams.brand" placeholder="请输入品牌" style="width: 150px;" size="small"></el-input>
      </div>
      <el-button @click="getData" type="primary" size="small" class='searchBtn'>查询</el-button>
      <el-button @click="onClickReset" size="small">重置</el-button>
      <el-button @click="onClickAdd" type="primary" size="small">新增</el-button>
    </div>
    <div class="row-wrap">
      <div style="display: flex; align-items: center;">
        <el-button @click="onClickDownloadTemplate" type="text">下载模版</el-button>
        <batch-import :uploadUrl='uploadUrl' @importSuccess='getData' @triggerLoading='importLoading = !importLoading' :params="{id: planId}"/>
        <el-button @click="onClickExportData" type="text">导出数据</el-button>
      </div>
    </div>
    <div class="content-wrap">
      <div class="content-inner">
        <el-table
          v-loading="tableLoad"
          :data='tableDatas'
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='委托商' prop='consignor' align='center' show-overflow-tooltip width="200px" />
          <el-table-column label='品牌' prop='brand' align='center' show-overflow-tooltip width="200px" />
          <el-table-column label='标车系数' prop='standardCarCoefficient' align='center' show-overflow-tooltip width="150px" />
          <el-table-column label='运输方式' prop='transportType' align='center' show-overflow-tooltip width="150px" />
          <el-table-column label='起始地' prop='origin' align='center' show-overflow-tooltip width="150px" />
          <el-table-column label='目的地' prop='destination' align='center' show-overflow-tooltip width="150px" />
          <el-table-column label='运输工具' prop='transportVehicles' align='center' show-overflow-tooltip width="150px" />
          <el-table-column label='平均距离KM' prop='averageDistance' align='center' show-overflow-tooltip width="150px" />
          <el-table-column label='数量（自然车）' prop='quantity' align='center' show-overflow-tooltip width="150px" />
          <el-table-column label='收入' prop='income' align='center' show-overflow-tooltip width="150px" />
          <el-table-column label='成本' prop='cost' align='center' show-overflow-tooltip width="150px" />
          <el-table-column label='毛利' prop='grossProfit' align='center' show-overflow-tooltip width="150px" />
          <el-table-column label='自然车折标车量' prop='foldedLabel' align='center' show-overflow-tooltip width="150px" />
          <el-table-column label='操作' width='210px' align='center' fixed="right">
            <template slot-scope='scope'>
              <el-button @click="onClickEdit(scope.row)" type="warning" size="small">修改</el-button>
              <el-button @click="onClickDelete(scope.row.id)" type="danger" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 新增/修改弹窗 -->
    <el-dialog :title='editTitle' :visible.sync='editDialogVisible' width='800px' center @close='editDialogClose' :close-on-click-modal='false' top='10vh'>
      <div class='company'>
        <el-form :model='editData' label-width='150px' label-position="right" :inline="true">
          <el-row>
            <el-col :span="12">
              <el-form-item label="委托商：">
                <el-select v-model="editData.consignor" placeholder="请选择委托商" size="small" style="width: 200px;" filterable>
                  <el-option v-for="item in consignorOption" :key="item.id" :label="item.customerName" :value="item.customerName"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="品牌：">
                <el-select v-model="editData.brand" placeholder="请选择品牌" size="small" style="width: 200px;" filterable>
                  <el-option v-for="item in brandOption" :key="item.id" :label="item.brand" :value="item.brand"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="标车系数：">
                <el-input v-model="editData.standardCarCoefficient" placeholder="请输入标车系数" size="small" style="width: 200px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="运输方式：">
                <el-select v-model="editData.transportType" placeholder="请选择运输方式" size="small" style="width: 200px;" filterable>
                  <el-option v-for="item in transportTypeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="起始地：">
                <el-input v-model="editData.origin" placeholder="请输入起始地" size="small" style="width: 200px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="目的地：">
                <el-input v-model="editData.destination" placeholder="请输入目的地" size="small" style="width: 200px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="运输工具：">
                <el-input v-model="editData.transportVehicles" placeholder="非ms车" size="small" style="width: 200px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="平均运距km：">
                <el-input v-model="editData.averageDistance" placeholder="请输入平均运距km" size="small" style="width: 200px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="数量（自然车）：">
                <el-input v-model="editData.quantity" placeholder="请输入数量（自然车）" size="small" style="width: 200px;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class='btnContainer'>
          <el-button class='searchBtn' @click='onClickSure' size='small'>确定</el-button>
          <el-button class='resetBtn' @click='editDialogVisible = false' size='small'>取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import BatchImport from '@/components/batchImport';
  import { getMapCustomer, getMapBrands, yearMonthPlanHighwayAddAll, yearMonthPlanHighwayList, yearMonthPlanHighwayDeleteAll, yearMonthPlanHighwayUpdateAll } from '@/service/vehiclelog';
  export default {
    components: { BatchImport },
    props: ['planId'],
    data() {
      return {
        importLoading: false,
        uploadUrl: '/yearMonthPlanHighway/all/import',
        searchParams: {
          consignor: '',
          brand: '',
        },
        tableLoad: false,
        tableDatas: [],
        editTitle: '',
        editDialogVisible: false,
        editData: {
          consignor: '', // 委托商
          brand: '', // 品牌
          standardCarCoefficient: '', // 标车系数
          transportType: '', // 运输方式
          origin: '', // 起始地
          destination: '', // 目的地
          transportVehicles: '', // 运输工具
          averageDistance: '', // 平均运距km
          quantity: '', // 数量（自然车）
        },
        consignorOption: [],
        brandOption: [],
        transportTypeOption: [
          { label: '纯公路', value: '纯公路' },
          { label: '水运集港', value: '水运集港' },
          { label: '短驳配送', value: '短驳配送' },
        ],
      }
    },
    methods: {
      onClickExportData() {
        window.exportExcelAll('get', '/yearMonthPlanHighway/all/exportXls', {planId:this.planId, ...this.searchParams});
      },
      onClickDownloadTemplate() {
        window.exportExcelAll('get', '/yearMonthPlanHighway/all/export', {});
      },
      onClickDelete(id) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const {status, message} = await yearMonthPlanHighwayDeleteAll({ids: id});
          if (status !== 0) return this.$message.error(message);
          this.$message.success(message);
          this.getData();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      onClickEdit(row) {
        this.editTitle = '修改';
        this.editData = {
          planId: this.planId,
          ...row,
        }
        this.editDialogVisible = true;
      },
      onClickReset() {
        this.searchParams = {
          consignor: '',
          brand: '',
        }
      },
      async getData() {
        this.tableLoad = true;
        const { data } = await yearMonthPlanHighwayList({
          ...this.searchParams,
          planId: this.planId,
        });
        console.log(data);
        this.tableDatas = [];
        Object.keys(data).forEach((key) => {
          this.tableDatas = this.tableDatas.concat(data[key]);
        })
        this.tableLoad = false;
        
      },
      onClickBack() {
        this.$emit('setPageType', 0);
      },
      onClickAdd() {
        this.editTitle = '新增';
        this.editData = {
          planId: this.planId,
          consignor: '', // 委托商
          brand: '', // 品牌
          standardCarCoefficient: '', // 标车系数
          transportType: '', // 运输方式
          origin: '', // 起始地
          destination: '', // 目的地
          transportVehicles: '', // 运输工具
          averageDistance: '', // 平均运距km
          quantity: '', // 数量（自然车）
        }
        this.editDialogVisible = true;
      },
      async onClickSure() {
        if (this.editTitle == '新增') {
          const { status, message } = await yearMonthPlanHighwayAddAll(this.editData);
          if (status !== 0) return this.$message.error(message);
          this.$message.success(message);
          this.editDialogVisible = false;
        } else {
          const { status, message } = await yearMonthPlanHighwayUpdateAll(this.editData);
          if (status !== 0) return this.$message.error(message);
          this.$message.success(message);
          this.editDialogVisible = false;
        }
        this.getData();
      },
      editDialogClose() {},
      async getOption() {
        const resConsignor = await getMapCustomer();
        const resBrand = await getMapBrands();
        this.consignorOption = resConsignor.data;
        this.brandOption = resBrand.data;
      },
    },
    mounted() {
      this.getOption();
    },
  }
</script>

<style lang="scss" scoped>
  .highway-wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    .top-wrap {
      display: flex;
    }
    .row-wrap {
      display: flex;
      justify-content: right;
    }
    .content-wrap {
      flex: 1;
      position: relative;
      overflow-y: auto;
      .content-inner {
        position: absolute;
        width: 100%;
      }
    }

    .mr20 {
      margin-right: 20px;
    }
  }
</style>
